<template>
  <el-dialog
    title="Please Enter Your Reason *"
    :visible.sync="visible"
    width="40%"
    @close="$emit('update:show', false)"
  >
    <el-row v-loading="loading">
      <el-form ref="applyForm" :model="apply" label-width="80px" :rules="rules">
        <el-form-item label="Channel" prop="aid">
          <el-select v-model="apply.aid" filterable placeholder="Select Channel">
            <el-option
              v-for="item in channel_list"
              :key="item.id"
              :label="item.id + ':' + item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Reason" prop="reason">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="Why do you want to apply for this offer？"
            v-model="apply.reason"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-row>

    <div class="footer" slot="footer">
      <el-button type="button" @click="cancel()">Cancel</el-button>
      <el-button type="primary" @click="doApply()">Apply</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      offer: '',
      aid: '',
      offer_id: '',
      channel_list: [],
      apply: {},
      visible: this.show,

      loading: false,
      rules: {
        aid: [{ required: true, message: 'Can\'t be empty!', trigger: 'change' }],
        reason: [{ required: true, message: 'Can\'t be empty!', trigger: 'change' }],
      },
    }
  },
  created() {
    this.offer = this.detailApply.offer
    this.aid = this.detailApply.aid
    this.offer_id = this.offer.oid
    this.channel_list = this.detailApply.channel_list
    this.link_type = this.detailApply.link_type

    if (this.channel_list.length) {
      this.apply.aid = this.aid
    }
    if (this.detailApply.link_type) {
      this.apply.link_type = this.detailApply.link_type
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    detailApply: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  methods: {
    doApply() {
      this.$refs['applyForm'].validate(valid => {
        if (valid) {
          this.loading = true
          this.apply.id = this.offer_id
          this.$http
            .post('/api/aff/ads/appl-r/', this.apply)
            .then(() => {
              this.loading = false
              this.$emit('apply')
            })
            .catch(err => {
              this.loading = false
              this.notifyOpen('Error', this.executeError(err), 'error')
            })
        }
      })
    },
    cancel() {
      this.$emit('cancel')
    },
  },
  components: {},
}
</script>
